import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const getProductionEmployees = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    const baseUrl = '/api/production-employees';

    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const productionEmployeesAPI = {
    getProductionEmployees
}

export default productionEmployeesAPI
